import React, { useEffect, useState } from "react";
import { getAllWalletReport } from "../../api/fetch";

function Provider() {
  const [allWallet, setAllWallet] = useState([]);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    fetchAllWallet();
  }, []);

  const fetchAllWallet = async () => {
    setLoading(true);
    try {
      const res = await getAllWalletReport();
      console.log("RESS ::", res);

      setAllWallet(res?.data);
    } catch (error) {
      console.log("Error ::", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    allWallet,
    isLoading,
  };
}

export default Provider;
